module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_vestland_pos.e5690d46.svg";